<template>
  <section class="hero is-primary is-fullheight">
    <b-loading :is-full-page="true" :active.sync="loggingIn" :can-cancel="false" />
    <div class="hero-body">
      <div class="container">
        <div class="columns">
          <div class="column">
            <img class="loginpic" src="../assets/image-login.png">
          </div>
          <div class="column">
            <form @submit.prevent="loginSubmit" class="formlogin">
              <div class="heading">
                <h1 class="title">
                  Toolindo
                </h1>
                <h2 class="subtitle">
                  Summary
                </h2>
              </div>
              <b-field label="Username">
                <b-input
                  type="text"
                  v-model="user"
                  placeholder="Your username"
                  required>
                </b-input>
              </b-field>
              <b-field label="Password">
                <b-input
                  type="password"
                  v-model="password"
                  password-reveal
                  placeholder="Your password"
                  required>
                </b-input>
              </b-field>
              <button class="button is-success" type="submit">Login</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'login',
  data() {
    return {
      user: '',
      password: '',
    };
  },
  computed: {
    ...mapState([
      'loggingIn',
      'loginError',
    ]),
  },
  methods: {
    ...mapActions([
      'doLogin',
    ]),
    loginSubmit() {
      this.doLogin({ user: this.user, pass: this.password }).then((res) => {
        if (res === 'success') {
          this.$router.push('/');
        }
      }, (e) => {
        this.$dialog.alert(e);
      });
    },
  },
};
</script>
<style lang="scss">
.loginpic {
  width: 100%;
}
.formlogin {
  text-align: left;
  padding: 0rem 10rem;
  @media screen and (max-width: 768px) {
    padding: 2rem;
  }
  .field label {
    color: #FFFFFF;
  }
  .heading {
    margin-top: 3rem;
  }
}
</style>
